export default {
    title: 'Strategic pillars',
    description:
        "Define the strategic directions that will guide your organization's objectives and initiatives.",
    addPillar: 'Add a pillar',
    editPillar: 'Edit the pillar',
    modalSubtitle: 'Define a strategic direction for your organization',
    noPillars: 'No strategic pillar defined yet.',
    nameLabel: 'Pillar name',
    namePlaceholder: 'e.g. Innovation excellence, Operational efficiency',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Describe what this strategic pillar aims to achieve...',
    nameRequired: 'The pillar name is required.',
    nameMaxLength: 'The pillar name must not exceed {{max}} characters.',
    descriptionMaxLength: 'The description must not exceed {{max}} characters.',
    nameDuplicateError: 'A pillar with this name already exists.',
    detailsTab: 'Details',
    translationsTab: 'Translations',
    edit: 'Edit',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activated: 'activated',
    deactivated: 'deactivated',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    add: 'Add pillar',
    close: 'Close',
    saveSuccess: 'Pillar saved.',
    deleteTitle: 'Delete the pillar "{{name}}"?',
    deleteMessage: 'This action is irreversible. The pillar will be permanently deleted.',
    deleteSuccess: 'Pillar deleted.',
    toggleStatusSuccess: '{{name}} has been {{action}}.',
    errorLoadingPillars: 'Error loading strategic pillars',
    moreOptions: 'More options',
    // Status
    statusLabel: 'Status',
    status: {
        active: 'Active',
        draft: 'Draft',
        inactive: 'Inactive',
    },
    // Period
    periodLabel: 'Period (optional)',
    periodStartLabel: 'Start date',
    periodEndLabel: 'End date',
    periodIndefinite: 'Stay active indefinitely',
    periodStartRequired: 'A start date is required when an end date is set.',
    periodEndRequired: 'Add an end date, or check "Stay active indefinitely".',
    periodEndBeforeStart: 'The end date must be on or after the start date.',
    periodRange: 'From {{start}} to {{end}}',
    periodSince: 'Since {{start}}',
    // Deactivation
    deactivateTitle: 'Deactivate the strategic pillar',
    deactivateMessage: 'Are you sure you want to deactivate "{{name}}"?',
    moveToDraftTitle: 'Move the strategic pillar back to draft',
    moveToDraftMessage: 'Are you sure you want to move "{{name}}" back to draft?',
    moveToDraft: 'Move to draft',
    deactivateImpactCount_one:
        '{{count}} objective keeps this pillar. It will no longer be offered for new objectives until it is reactivated.',
    deactivateImpactCount_other:
        '{{count}} objectives keep this pillar. It will no longer be offered for new objectives until it is reactivated.',
    deactivateImpactNone:
        'It will no longer be offered for new objectives until it is reactivated.',
    moveToDraftImpactCount_one:
        '{{count}} objective keeps this pillar. It will no longer be offered for new objectives while it stays a draft.',
    moveToDraftImpactCount_other:
        '{{count}} objectives keep this pillar. It will no longer be offered for new objectives while it stays a draft.',
    moveToDraftImpactNone:
        'It will no longer be offered for new objectives while it stays a draft.',
    // Deletion
    deleteImpactCount_one: '{{count}} objective will no longer be linked to this pillar.',
    deleteImpactCount_other: '{{count}} objectives will no longer be linked to this pillar.',
    deleteImpactNone: 'No objective is linked to this pillar.',
    // Objectives and pillars
    settings: {
        title: 'Company settings',
    },
    multiplePillars: {
        label: 'Allow several pillars per objective',
        loadError: 'The setting could not be loaded.',
        saveSuccess: 'Setting saved.',
        confirmTitle: 'Allow only one pillar per objective?',
        confirmMessage_one:
            '{{count}} objective is linked to several pillars. It keeps them: its pillars can then only be removed, not added.',
        confirmMessage_other:
            '{{count}} objectives are linked to several pillars. They keep them: their pillars can then only be removed, not added.',
        confirmMessageWithoutCount:
            'Objectives linked to several pillars keep them: their pillars can then only be removed, not added.',
        confirmLabel: 'Allow only one',
    },
    objectiveWithoutPillar: {
        label: 'Allow an objective without a strategic pillar',
        help: 'Otherwise, every published objective must be linked to a pillar. A draft can wait.',
        saveSuccess: 'Setting saved.',
    },
    unaligned: {
        count_one: '{{count}} objective is linked to no pillar.',
        count_other: '{{count}} objectives are linked to no pillar.',
        none: 'No objective is left without a pillar.',
        loadError: 'The number of objectives linked to no pillar could not be loaded.',
    },
    // Errors
    errors: {
        activeLimitReached:
            'The maximum of {{max}} active pillars has been reached. Deactivate a pillar before activating another one.',
    },
};
